import React from 'react';
import { CONFIG } from 'config/config';
import { Text, View } from '@coinscrap/webapp-core';
import { SectionTitle } from 'components/SectionTitle/SectionTitle';
import TextSpan from 'components/TextSpan/TextSpan';
import ToogleSwitch from 'components/ToogleSwitch/ToogleSwitch';

export const Privacity = ({ advertising, setAdvertising }) => {
	return (
		<>
			<SectionTitle
				title={'Política de privacidad'}
				style={{ marginTop: 42, marginBottom: 16 }}
				showLine={false}
			/>

			<View rowSt fullWidthSt justifyBetweenSt marginBottomMdSt>
				<Text>
					Quiero recibir comunicaciones personalizadas de Allianz adaptadas a mi perfil e
					intereses.
				</Text>

				<ToogleSwitch checked={advertising} onChange={setAdvertising} />
			</View>

			<Text>
				Haciendo clic en el botón consientes que Allianz Seguros España, como responsable
				del tratamiento, utilice sus datos para ponerse en contacto con usted y atender su
				petición. Para más detalle y como ejercer sus derechos de acceso, rectificación,
				oposición, supresión, limitación y portabilidad, consulte nuestra{' '}
				<TextSpan
					style={{
						cursor: 'pointer',
						color: CONFIG.colors.primary,
						fontFamily: CONFIG.fonts.semiBold,
					}}
					onClick={() => {
						window.open(
							'https://www.allianz.es/informacion-legal.html#privacidad',
							'_blank',
						);
					}}
				>
					Política de Privacidad
				</TextSpan>
				.
			</Text>
		</>
	);
};
